import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 376px;
  padding: 1rem 1rem 1.5rem;
  background: var(--white);
  border-radius: 0.5rem;
  border: 1px solid var(--cinza-40);
  /* margin-right: 1.5rem; */

  > a {
    display: flex;
    gap: 8px;
    flex-direction: column;
    width: 100%;
    margin-bottom: 32px;
    text-decoration: none;

    > p {
      font-size: 15px;
      line-height: 24px;
      letter-spacing: 0.2px;
      font-weight: 700;
      color: var(--cinza-100);
      margin-bottom: 0;
    }
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  margin-bottom: 1.375rem;

  /* Nome e impressora numa linha própria; o número do pedido vem abaixo.
     Antes eram irmãos num flex com wrap e, sem a impressora, o h3 (base 0)
     cabia na mesma linha do número e ficava com largura zero — o nome
     vazava por cima do "Pedido PT…". */
  .titulo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
  }

  h3 {
    flex: 1 1 auto;
    min-width: 0;
    font-size: 1.5rem;
    line-height: 1.75rem;
    font-weight: 700;
  }

  .titulo > a {
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--principal-50);
    border-radius: 8px;
    height: 40px;
    padding: 0 8px;
    text-decoration: none;
    cursor: pointer;

    svg {
      font-size: 1.5rem;
      color: var(--white);
    }
  }

  .selo-exigencia {
    flex: 0 0 auto;
    padding: 4px 12px;
    border-radius: 20px;
    background: var(--atencao-10);
    color: var(--atencao-50);
    font-size: 13px;
    font-weight: 700;
  }
`;

export const CardService = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 1rem;

  & + div {
    margin-top: 32px;
  }

  &.next {
    align-items: center;
    padding-top: 1.5rem;

    svg {
      color: var(--atencao-50);
      margin-bottom: 0.5rem;
    }

    p {
      &.service {
        margin-bottom: 0.25rem;
      }

      &.history {
        font-size: var(--font-17);
        color: var(--cinza-90);
        margin-bottom: 0.25rem;
        text-align: center;
      }

      /* &.date {
                font-size: var(--font-17);
                color: var(--principal-50);
                font-weight: 700;
            } */
    }
  }

  &.analysis {
    margin-bottom: 0;
    gap: 8px;

    > p {
      font-size: 15px;
      line-height: 24px;
      letter-spacing: 0.2px;
      font-weight: 700;
      color: var(--cinza-100);
      margin-bottom: 0;
    }
  }

  &.dispatch {
    margin: 24px 0;
    gap: 8px;

    > p {
      font-size: 15px;
      line-height: 24px;
      letter-spacing: 0.2px;
      font-weight: 700;
      color: var(--cinza-100);
      margin-bottom: 0;
    }
  }

  p {
    font-size: 1.1875rem;
    line-height: 1.75rem;
    color: var(--cinza-90);
    margin-bottom: 1.5rem;

    &.service {
      font-size: 0.9375rem;
      letter-spacing: 1.5px;
      font-weight: 700;
      color: var(--cinza-100);
      text-transform: uppercase;
      margin-bottom: 0.5rem;
    }

    &.margin-none {
      margin: 0;
    }
  }

  hr {
    width: 100%;
    height: 1px;
    background: var(--cinza-30);
    border: 0;
  }
`;

export const CardAppended = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 0.75rem;
  margin-bottom: 1.75rem;

  div.appended-header {
    display: flex;
    gap: 5px;
    align-items: center;
  }

  div.cardStatus {
    margin: 12px 0;

    svg {
      width: 20px;
      height: 20px;
    }
  }

  h3 {
    font-size: 1.188rem;
    line-height: 2rem;
    font-weight: 700;
    color: #2c2c2c;
  }

  p {
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: #767676;
    font-weight: 400;
    margin-bottom: 0;

    &.status {
      font-size: 0.938rem;
      line-height: 1.5rem;
      color: #42455f;
      font-weight: 700;
    }
  }
`;

export const CardStats = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 2rem;

  > p {
    &:first-child {
      font-size: 0.9375rem;
      line-height: 1.75rem;
      letter-spacing: 1.5px;
      font-weight: 700;
      color: var(--cinza-100);
      text-transform: uppercase;
      margin-bottom: 0.5rem;
    }

    &.analysisText {
      font-size: 15px;
      line-height: 24px;
      color: var(--cinza-80);
      letter-spacing: 0.2px;
      margin-top: 8px;
    }

    &.followUp {
      font-size: 15;
      line-height: 24px;
      letter-spacing: 0.2px;
      color: var(--cinza-70);
    }
  }

  > div.indicators {
    display: flex;
    justify-content: space-between;

    > p {
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 0.2px;
      color: var(--cinza-100);
    }
  }
`;

export const CardPercent = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.0625rem;
  line-height: 1.75rem;
  font-weight: 700;
  color: ${({ color }) => (color ? [color] : "")};

  &.m4 {
    margin: 4px 0;
  }

  span {
    &.bar {
      width: 100%;
      background: var(--cinza-30);
      border-radius: 0.5rem;
    }

    &.percent {
      margin: 0 0 0 0.5rem;
    }
  }
`;

export const LinePercent = styled.div`
  width: ${({ size }) => (size ? [size] + "%" : 0)};
  height: 0.75rem;
  background: ${({ color }) => (color ? [color] : "")};
  border-radius: 0.5rem;
`;

export const StatsInfo = styled.div`
  display: flex;
  align-items: center;
  color: ${({ color }) => (color ? [color] : "")};

  &.analysis {
    margin: 16px 0 8px;

    > span {
      font-size: 17px;
      line-height: 28px;
      font-weight: bold;
      margin-left: 12px;
    }

    > p {
      font-size: 15px;
      line-height: 24px;
      letter-spacing: 0ch.2px;
    }
  }

  span {
    font-size: 0 0.9375rem;
    line-height: 1.5rem;
    margin-left: 0.5rem;
  }
`;

export const Prediction = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
  margin-top: 8px;
  margin-bottom: 24px;

  > svg {
    color: var(--principal-50);
  }

  > p {
    font-size: 15px;
    line-height: 24px;
    color: var(--cinza-90);
  }

  > div {
    display: flex;
    flex-direction: column;

    > p {
      font-size: 15px;
      line-height: 24px;
      letter-spacing: 0.2px;
      color: var(--cinza-90);
    }
  }
`;

// Aviso de apostila no topo da documentação (Essencial/2026), no formato da
// caixa "Sobre a transcrição", em laranja.
export const AvisoApostila = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  margin-top: 16px;
  padding: 12px 14px;
  background: var(--atencao-10);
  border-left: 3px solid var(--atencao-50);
  border-radius: 0 8px 8px 0;

  > strong {
    font-size: 15px;
    line-height: 24px;
    color: #573A00;
  }

  > p {
    font-size: 15px;
    line-height: 22px;
    color: #573A00;
    margin: 0;
  }
`;
